<template>
  <div>
    <h3>Add Hospital</h3>
    <el-divider></el-divider>
    <el-form :model="hospitalData">
      <el-row gutter="15">
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
          <label for="Ordering Facility Name"
            ><span class="star">*</span></label
          >
          <el-input
            v-model="hospitalData.name"
            placeholder="Enter Ordering Facility Name"
          ></el-input>
          <p class="star"><FormError errorName="name"></FormError></p>
        </el-col>
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
          <label for="Code">Code<span class="star">*</span></label>
          <el-input
            v-model="hospitalData.code"
            placeholder="Enter Code"
          ></el-input>
          <p class="star"><FormError errorName="code"></FormError></p>
        </el-col>
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
          <label for="Phone Number"
            >Phone Number<span class="star">*</span></label
          >
          <el-input
            maxlength="10"
            v-model="hospitalData.phone"
            placeholder="Enter Phone Number"
          ></el-input>
          <p class="star"><FormError errorName="phone"></FormError></p>
        </el-col>
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
          <label for="Fax">Fax</label>
          <el-input
            maxlength="10"
            v-model="hospitalData.fax"
            placeholder="Enter Fax"
          ></el-input>
        </el-col>
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
          <label for="Email">Email</label>
          <el-input
            v-model="hospitalData.email"
            placeholder="Enter Email"
            class="email-lower"
            type="email"
          ></el-input>
        </el-col>
        <el-col :xl="7" :lg="6" :md="8" :sm="12" :xs="12">
          <label for="Address Line 1">Address Line 1</label>
          <el-input
            v-model="hospitalData.address_line_1"
            placeholder="Enter Address Line 1"
          ></el-input>
        </el-col>
      </el-row>

      <el-row gutter="15">
        <el-col :xl="7" :lg="6" :md="8" :sm="12" :xs="12">
          <label for="Address Line 2">Address Line 2</label>
          <el-input
            v-model="hospitalData.address_line_2"
            placeholder="Enter Address Line 2"
          ></el-input>
        </el-col>
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
          <label for="Zip">Zip<span class="star">*</span></label>
          <el-input
            maxlength="5"
            type="number"
            v-model="hospitalData.zip"
          ></el-input>
          <p class="star"><FormError errorName="zip"></FormError></p>
        </el-col>
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
          <div>
            <state :stateData="hospitalData"></state>
          </div>
          <p class="star"><FormError errorName="state"></FormError></p>
        </el-col>
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
          <div>
            <city :cityData="hospitalData"></city>
          </div>
          <p class="star"><FormError errorName="city"></FormError></p>
        </el-col>
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
          <label for="NPI">NPI<span class="star">*</span></label>
          <el-input maxlength="10" v-model="hospitalData.npi"></el-input>
          <p class="star"><FormError errorName="npi"></FormError></p>
        </el-col>
      </el-row>
    </el-form>

    <div>
      <el-row>
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12" :offset="16">
          <el-button @click="cancel">Cancel</el-button>
        </el-col>
        <el-col :xl="3" :lg="3" :md="8" :sm="12" :xs="12">
          <el-button type="success" @click="addNewHospital"
            >Update</el-button
          ></el-col
        >
      </el-row>
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
const state = defineAsyncComponent(() => import("@/components/misc/State"));
const city = defineAsyncComponent(() => import("@/components/misc/City"));
import AppHelper from "@/mixins/AppHelper";
const FormError = defineAsyncComponent(() =>
  import("@/components/misc/FormError")
);
import { mapGetters } from "vuex";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  components: {
    state,
    city,
    FormError,
  },
  mixins: [AppHelper],
  data() {
    return {
      hospitalData: {
        name: "",
        code: "",
        phone: "",
        fax: "",
        email: "",
        address_line_1: "",
        address_line_2: "",
        state: "",
        city: "",
        zip: "",
        npi: "",
        marketers_count: "",
      },
    };
  },
  computed: {
    ...mapGetters("hospitals", [
      "getHospitalAddStatus",
      "getAddedHospitalData",
      "getSingleHospital",
    ]),
    ...mapGetters("errors", ["getErrors", "getError"]),
  },
  mounted() {
    if (this.getSingleHospital) {
      this.hospitalData = {
        ...this.hospitalData,
        ...this.getSingleHospital,
      };
    }
  },
  methods: {
    getHospitalFormData() {
      return this.getFormattedValues(this.hospitalData);
    },
    cancel() {
      this.$router.push({ name: "HospitalDetails" });
    },
    async addNewHospital() {
      try {
        let params = this.getHospitalFormData();
        if (params.email) {
          params.email = params.email.toLowerCase();
        }
        await this.$store.dispatch("hospitals/addHospital", params);
        if (this.getHospitalAddStatus) {
          const newHospitalId = this.getAddedHospitalData._id;

          successNotification("New Hospital Created Successfully");
          this.cancel(newHospitalId);
        } else {
          if (!this.getErrors || this.getError) {
            errorNotification("Error while creating New Hospital");
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style lang="scss">
.star {
  color: red;
}
</style>
